/**
 * MUI TextField `sx` — stesso aspetto dei campi Login / UserForm (sfondo flat, angoli arrotondati, outline nascosto).
 * @param {import('@mui/material').Theme} theme
 */
export function appFlatTextFieldSx(theme) {
  const isDark = theme.palette.mode === 'dark'
  return {
    background: isDark ? theme.palette.grey[800] : theme.palette.newColors.lightGray,
    borderRadius: 4,
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        border: 'none',
      },
      '&:hover fieldset': {
        border: 'none',
      },
      '&.Mui-focused fieldset': {
        border: 'none',
      },
    },
  }
}
